// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"9385afbf","469":"c1143f2d"}[chunkId] + ".chunk.css";
};